/* eslint-disable indent */
function getTendencyClass(data) {
  const { seats, prevSeats } = data;

  if (!prevSeats || seats > prevSeats) {
    return "up";
  }

  if (seats < prevSeats) {
    return "down";
  }

  return "even";
}

function setPositionTooltip(tooltip, x, y) {
  const tooltipToPositionate = tooltip;
  const left = x - tooltipToPositionate.offsetWidth / 2;

  tooltipToPositionate.style.top = `${
    y - tooltipToPositionate.clientHeight - 15
  }px`;
  tooltipToPositionate.style.left = `${left}px`;
  tooltipToPositionate.style.display = "block";
  tooltipToPositionate.style.zIndex = "3";
  const bounding = tooltipToPositionate.getBoundingClientRect();

  if (bounding.x < 0) {
    tooltipToPositionate.style.left = `${left + Math.abs(bounding.x) + 5}px`;
  }

  if (bounding.x + bounding.width > document.body.clientWidth) {
    tooltipToPositionate.style.left = `${
      left - (bounding.x + bounding.width - document.body.clientWidth) - 5
    }px`;
  }

  if (
    tooltipToPositionate.parentElement.classList.contains("ac-amp") &&
    bounding.y < tooltipToPositionate.parentElement.getBoundingClientRect().y
  ) {
    tooltipToPositionate.style.top = `${y + 20}px`;
  }
}

function tooltipTemplate(data) {
  return `<div class="c-tooltip ${data.partyCode}">
    <div class="c-tooltip__text">
      <div class="c-tooltip__wrapper-text">
        <span class="c-tooltip__seats-prev ${getTendencyClass(
          data
        )} js-prev-escanos">
        </span>
        <p class="c-tooltip__partido js-party">${data.partyName}</p>
      </div>
          <p class="c-tooltip__seats">
            <span class="c-tooltip__seats-number js-escanos">${
              data.seats
            }</span>
            <span class="c-tooltip__seats-text">${
              window.ac_labels.tooltip.election
            }</span>
          </p>
      </p>
      <p class="c-tooltip__votos js-votes"> ${data.votes} ${
    window.ac_labels.tooltip.votes
  }</p>
    </div>
  </div>`;
}

function renderParties(data) {
  const { parties } = data.dataVoting;
  let table = `<caption class="c-tooltip__caption js-province-name">${data.nameProvince}</caption>
  <tbody class="c-tooltip__table-tbody">`;
  parties.forEach((party) => {
    table += `
      <tr class="c-tooltip__table-tr">
        <td class="c-tooltip__party ${party.partyCode} js-party">${party.partyName}</td>
        <td class="c-tooltip__porcentaje js-votes">
          &nbsp;${party.votesPct}% ${window.ac_labels.tooltip.votes}
        </td>
      </tr>
    `;
  });
  table += "</tbody>";

  return table;
}

function tooltipMapTemplate(data) {
  return `
    <span class="c-tooltip c-tooltip--localidad u-hidden@md--down">
      <table class="c-tooltip__table js-table">${renderParties(data)}</table>
      <span class="c-tooltip__escrutinio js-escrutinio">
        ${data.dataVoting.voting.votesCountedPct}% ${window.ac_labels.tooltip.counted}
      </span>
    </span>
  `;
}

function builTooltip(tooltip, data) {
  const newTooltip = tooltip;
  const partyName = newTooltip.querySelector(".js-party");
  const votes = newTooltip.querySelector(".js-votes");

  if (data.isForMap) {
    newTooltip.querySelector(".js-table").innerHTML = renderParties(data);
    newTooltip.querySelector(
      ".js-escrutinio"
    ).innerHTML = `${data.dataVoting.voting.votesCountedPct}% \
    ${window.ac_labels.tooltip.counted}`;
  } else {
    const classToReplace = tooltip.classList.value.split(" ")[1];
    newTooltip.classList.replace(classToReplace, data.partyCode);
    partyName.innerHTML = data.partyName;
    if (newTooltip.querySelector(".js-escanos")) {
      newTooltip.querySelector(".js-escanos").innerHTML = data.seats;
    }
    if (newTooltip.querySelector(".js-prev-escanos") && data.prevSeats) {
      const tendencyClass = getTendencyClass(data);
      newTooltip
        .querySelector(".js-prev-escanos")
        .classList.remove("up", "down", "even");
      newTooltip.querySelector(".js-prev-escanos").classList.add(tendencyClass);
      // newTooltip.querySelector(".js-prev-escanos").innerHTML = data.prevSeats;
    }
    if (votes) {
      votes.innerHTML = ` ${data.votesPct}% ${window.ac_labels.tooltip.votes}`;
    }
  }

  return newTooltip;
}

function show(data, graph, x, y) {
  let tooltip = graph.querySelector(".c-tooltip");

  if (tooltip) {
    tooltip = builTooltip(tooltip, data);
    setPositionTooltip(tooltip, x, y);
  } else {
    tooltip = data.isForMap ? tooltipMapTemplate(data) : tooltipTemplate(data);
    graph.insertAdjacentHTML("beforeend", tooltip);
    setPositionTooltip(graph.querySelector(".c-tooltip"), x, y);
  }
}

function hide(graph) {
  const tooltip = graph.parentNode.querySelector(".c-tooltip");
  if (tooltip) {
    tooltip.style.display = "none";
  }
}

export default {
  show,
  hide,
};
